import React from 'react';
import { IPanelProps, Panel as BasePanel } from '@fluentui/react';
import './styles.css';
//TODO: Add this to shared components?
const getClassName = (props: IPanelProps): string => {
    let className = 'TALXIS__panel';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return className;
};

const Panel: React.FC<IPanelProps> = (props) => {
    return <BasePanel
        {...props}
        className={getClassName(props)}
    />;
};
export default Panel;